<template>
  <div class="container">
    <div class="top">
      <p>
        <span>员工管理</span>
        <span>&nbsp;&nbsp;(共{{total?total:0}}人)</span>
      </p>
      <div class="search-warp">
        <el-select
          v-model="value"
          @change="searchList"
        >
          <el-option label="全部部门" value = '全部部门'></el-option>
          <el-option
            v-for="item in options"
            :key='item.id'
            :label="item.name"
            :value="item.id"

          >{{item.name}}</el-option>
          <el-option label="无部门" value=''></el-option>
        </el-select>
        <el-input
          class="search"
          placeholder="请输入姓名或手机号"
          v-model="searchStr"
          @input ="inputChange(searchStr)"
          >
        <i slot="suffix"
          class="el-input__icon el-icon-search"
          @click="querySearch(searchStr)"
        ></i>
        </el-input>
        <el-button type="primary" @click="addUserWarp">录入员工</el-button>
      </div>
    </div>
    <el-table :data="mates"
              style="width: 100%">
      <el-table-column prop="realname"
                        label="姓名"
                        min-width="80"
                        align='center'
                        >
      </el-table-column>
      <el-table-column prop="phone"
                        label="手机号"
                        min-width="120"
                        align='center'
                      >
      </el-table-column>
      <el-table-column prop="name"
                        label="所在部门"
                        min-width="120"
                        align='center'
                        >
      </el-table-column>
      <el-table-column prop="createTime"
                        label="加入时间"
                        min-width="200"
                        align='center'
                        >
                        <template slot-scope="scope">
                          {{scope.row.createTime.replace(/\-/g, "/")}}
                        </template>
      </el-table-column>
      <el-table-column prop="status"
                        label="状态"
                        :formatter="statusFormatter"
                        align='center'
                        >
      </el-table-column>
      <!-- <el-table-column prop="sum"
                        label="收到福利总额（元）"
                        :formatter="moenyFomat"
                        align='center'
                        >
      </el-table-column> -->
      <el-table-column prop="identity"
                        label="操作权限"
                        :formatter="idFormatter"
                        align='center'
                        >
      </el-table-column>
      <el-table-column
                        label="操作"
                        align='center'
                        >
        <template slot-scope="scope">
          <!-- 直接在click事件上把当前要操作的用户的信息赋值了，省去了在写一个方法，不过这种写法合适不合适需要讨论 -->
          <el-button @click.native.prevent="editClick(scope.row)"
          v-if="company.identity == 1"
                      type="text">
            修改信息
          </el-button>
          <el-button @click.native.prevent="delVisible = true;userId =  scope.row.userId;currentName =  scope.row.realname; account = scope.row.account"
                      type="text">
            请离员工
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :page-size="pageSize"
      :current-page.sync="page"
      align='center'
      @current-change="pageChange"
      :total="total">
    </el-pagination>
    <el-dialog
      title="录入员工"
      :visible.sync="addVisible"
      width="30%">
      <el-input v-model="employeeName" :maxlength="10" placeholder="请输入员工姓名"></el-input>
      <el-input v-model="phone" style='margin: 20px 0px' :maxlength="11"  placeholder="请输入员工手机号"></el-input>
      <el-select
        class="select"
        v-model="tagValue"
        size="small"
        @change="selectChange"
      >
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.name"
          :value="item.id"
        >
          <span>{{item.name}}</span>
          <!-- <span  class="delIcon el-icon-close" @click.stop='deleteTag(item.id)'></span> -->
        </el-option>
      </el-select>
      <p v-show="showTip == 2 || showTip == 3" class="tip" :class="{error:showTip==3}">{{tipMsg}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser" :disabled="showTip == 3">确 定 添 加</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改员工信息"
      :visible.sync="editVisible"
      @close='closeDialog'
      width="30%">
      <el-input v-model="currentName"  :maxlength="10" placeholder="请输入员工姓名" ></el-input>
      <el-input v-model="currentPhone" :disabled='currentStatus' style='margin: 20px 0px' placeholder="请输入员工手机号"></el-input>
      <el-select
        class="select"
        v-model="oldTagValue"
        size="small"
        @change="selectChange"
      >
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.name"
          :value="item.id"
        >
          <span>{{item.name}}</span>
          <!-- <span  class="delIcon el-icon-close" @click.stop='deleteTag(item.id)'></span> -->
        </el-option>
      </el-select>
      <el-checkbox-group v-model="currentIden" class='checkbox'>
        <el-checkbox  :label="3" class='positive'>
          <span>福利制表人</span>
          <img src='../../assets/u1425.png' class='icon' title='福利制表人可申请福利发放，由福利审核人进行审核。'>
        </el-checkbox>
        <el-checkbox  :label="2" class='positive'>
          <span>福利审核人</span>
          <img src='../../assets/u1425.png' class='icon' title='福利审核人可审核福利的发放与扣除 ，添加/请离/编辑员工。'>
        </el-checkbox>
        <!-- <el-checkbox  :label="4" class='positive'>
          <span>员工管理员</span>
          <img src='../../assets/u1425.png' class='icon' title='员工管理员可添加/请离/编辑员工。'>
        </el-checkbox> -->
      </el-checkbox-group>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser">确 定 修 改</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog
      title="录入员工"
      :visible.sync="addVisible"
      width="30%">
      <el-input v-model="employeeName" :maxlength="10" placeholder="请输入员工姓名"></el-input>
      <el-input v-model="phone" style='margin: 20px 0px' placeholder="请输入员工手机号"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser">确 定 添 加</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      :title="'确定请离'+currentName+'?'"
      :visible.sync="delVisible"
      width="30%">
      <div class="box">
        <span class="font">该成员钱包余额：￥{{account}}元</span>
        <span class="tip" @click="deductionBox">扣除福利余额</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delVisible = false">取 消</el-button>
        <el-button type="primary" @click="delMate">确 定 请 离</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="'确定请离'+currentName+'?'"
      :visible.sync="delVisibles"
      :before-close="handleDialogClose"
      width="30%" class="confirm">
      <div class="box">
        <span class="font">扣除金额：</span>
        <el-input
          class="input"
          v-model="deductionInput"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
        ></el-input>
        <span class="unit">元</span>
      </div>
      <div class="prompt">
        <span>该成员钱包余额：￥{{parseFloat(account).toFixed(2)}}</span>
        <span class="assignment tip" @click="assignment">全部扣除</span>
      </div>
      <div class="tips" v-show ="tipShow">扣除金额不可大于钱包余额</div>
      <div class="remark">
        注：若该员工当前的钱包余额包含离职后的福利，请确认与员工
        签订好扣除协议后，在扣除相应的福利金额
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delVisibles = false">取 消</el-button>
        <el-button type="primary" @click="delMates" :disabled="isDisable">确认扣除并请离</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="succ"
      :before-close="handleDialogClose"
      class="succ"
      width="30%">
      <div class="boxs">
        <span class="font">成功请离员工<span class="color">{{currentName}}</span> ,</span>
        <span class="font" @click="deductionBox"> 并扣除福利金额 ：￥{{parseFloat(deductionInput).toFixed(2)}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script >
import { getDepartment } from '@/api/department'
import { getMatesByCompanyId, serMatesByCompanyId, editMateById, delMateById, delMateByIds, addMateById, getMateNameByPhone, serMatesByDepartment } from '@/api/mate'
import bus from '@/utils/bus'
import { validateTel } from '@/utils/validate'
export default {
  data () {
    return {
      tableData: [],
      addVisible: false,
      editVisible: false,
      delVisible: false,
      delVisibles: false,
      input: '',
      radio: 1,
      mates: [],
      companyId: '',
      searchStr: '',
      currentId: '', // 当前要操作的用户
      currentUserId: '', // 当前要操作的用户 这个值只有请离的时候用
      currentName: '', // 当前要操作的用户
      currentPhone: '', // 当前要操作的用户手机号
      currentStatus: false, // 当前要操作的用户是否已激活
      currentIden: [], // 当前要操作的用户的权限
      employeeName: '',
      phone: '',
      showTip: 1, // 2的时候为第二种情况，提示有员工，可继续添加   3的时候为该手机号码已存在当前组织中，提示语为红色，添加按钮为灰色，不可添加
      tipMsg: '',
      userNumber: '',
      account: '',
      deductionInput: '',
      tipShow: false,
      succ: false,
      userId: '',
      isDisable: false,
      page: 1,
      pageSize: 10,
      total: '',
      tagValue: '',
      oldTagValue: '',
      options: [],
      name: '',
      deptId: '',
      value: '全部部门',
      company: {}
    }
  },
  props: [],
  components: {
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.getMates(1)
    this.getOptions()
    this.company = JSON.parse(localStorage.company)
    bus.$on('changeCompany', (id) => {
      this.mates = []
      this.companyId = id
      this.value = '全部部门'
      this.getMates(1)
      this.getOptions()
      this.company = JSON.parse(localStorage.company)
    })
  },
  created () {
  },
  computed: {
    newSearchStr () {
      // this.querySearch(searchStr)
      this.searchStr + ''
      console.log(this.searchStr)
    }
  },
  watch: {
    phone (newValue, oldValue) {
      if (validateTel(newValue)) {
        getMateNameByPhone({ phone: newValue, companyId: localStorage.companyId }).then(res => {
          console.log(res)
          if (res.msg === 'success' && res.data) {
            this.showTip = 2
            this.tipMsg = `该用户注册名称：${res.data}`
          } else if (res.msg !== 'success') {
            this.showTip = 3
            this.tipMsg = res.msg
          }
        })
      } else {
        this.showTip = 1
        this.tipMsg = ''
      }
    }
  },
  methods: {
    getOptions () {
      let data = { companyId: this.companyId }
      getDepartment(data).then(res => {
        // console.log(res);
        this.options = res
      })
    },
    delMate () {
      delMateById(this.companyId, this.userId).then(res => {
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '请离成功'
          })
          this.delVisible = false
          this.getMates(1)
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    // 请离人元并退款
    delMates () {
      if (this.isDisable) return false
      this.isDisable = true
      if (!this.deductionInput) {
        this.$message('请输入扣除金额')
        this.isDisable = false
        return
      }
      if (this.deductionInput <= 0) {
        this.$message('请输入扣除金额必须大于0')
        this.isDisable = false
        return
      }
      if (Number(this.deductionInput) > Number(this.account)) {
        this.tipShow = true
        this.isDisable = false
        setTimeout(() => {
          this.tipShow = false
          this.deductionInput = ''
        }, 3000)
        return
      }
      setTimeout(() => { // 防止用户重复点击
        let device = this.device()
        let data = {
          'amount': this.regYuanToFen(this.deductionInput, 100),
          'companyId': this.companyId,
          'userId': this.userId,
          'device': device
        }
        delMateByIds(data).then(res => {
          this.isDisable = false
          this.delVisibles = false
          if (res.msg === 'success') {
            delMateById(this.companyId, this.userId).then(res => {
              if (res.msg === 'success') {
                setTimeout(() => {
                  this.succ = true
                }, 500)
                this.getMates(this.page)
              } else {
                this.$message({
                  type: 'warn',
                  message: res.msg
                })
              }
            })
          } else {
            this.isDisable = false
            this.delVisibles = false
            setTimeout(() => {
              this.$message({
                type: 'warn',
                message: '数据返回失败'
              })
            }, 500)
          }
        })
      }, 10)
    },
    handleClose () {
      this.dialogVisible = false
    },
    getMates (page) {
      let data = {
        id: this.companyId,
        page: page,
        size: this.pageSize
      }
      getMatesByCompanyId(data).then(res => {
        // console.log(res);
        this.mates = res.data.employeeList
        this.total = res.data.count
      })
    },
    editClick (obj) {
      // console.log(obj);
      this.currentId = obj.id
      this.currentName = obj.realname
      this.currentPhone = obj.phone
      this.currentStatus = !!obj.status
      this.oldTagValue = obj.name
      this.deptId = obj.dept_id
      // console.log(this.tagValue);
      let data = { companyId: localStorage.companyId }
      // console.log(data);
      getDepartment(data).then(res => {
        // console.log(res);
        this.options = res
      })
      switch (obj.identity) {
        case 1:
          this.currentIden = [2, 3]
          break
        case 2:
          this.currentIden = [2]
          break
        case 3:
          this.currentIden = [3]
          break
        case 4:
          this.currentIden = []// 为了不影响编辑权限，这快遇到是2的权限的人，就把checkboxgroup的绑定值写为空
          break
      }
      this.editVisible = true
    },
    editUser () {
      if (!this.currentName) {
        this.$message('请输入姓名')
        return
      }
      if (!validateTel(this.currentPhone)) {
        this.$message('请输入正确的手机号')
        return
      }
      if (!this.oldTagValue) {
        this.$message('请选择员工所属部门')
        return
      }
      /* 权限的话，因为el-checkbox绑定的数据是一个数组，所以整个页面逻辑里，涉及到权限的操作和展示的不分 就都在处理这个事情
        然后下面是提交时的数据，第一个判断是这个数组里 假如有两个值那么一定就是3，4权限了，这时候根据后台接口要求，传1
       */
      let data = {
        'companyId': localStorage.companyId,
        'employeeName': this.currentName,
        'id': this.currentId,
        'identity': this.currentIden.length >= 2 ? 1 : this.currentIden.length === 1 ? this.currentIden[0] : this.currentIden.length === 0 ? '4' : '4',
        'phone': this.currentPhone,
        'deptId': this.deptId
      }
      editMateById(data).then(res => {
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '编辑成功'
          })
          this.editVisible = false
          this.getMates(this.page)
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    // 新增员工弹框
    addUserWarp () {
      this.addVisible = true
      let data = { companyId: localStorage.companyId }
      getDepartment(data).then(res => {
        // console.log(res);
        this.options = res
      })
    },
    addUser () {
      if (!this.employeeName) {
        this.$message('请输入姓名')
        return
      }
      if (!validateTel(this.phone)) {
        this.$message('请输入正确的手机号')
        return
      }
      if (!this.tagValue) {
        this.$message('请选择员工所属部门')
        return
      }
      let data = {
        employeeName: this.employeeName,
        phone: this.phone,
        companyId: localStorage.companyId,
        deptId: this.deptId
      }
      console.log(data)
      addMateById(data).then(res => {
        console.log(res)
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.addVisible = false
          this.employeeName = ''
          this.phone = ''
          this.getMates(this.page)
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    timeFomatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    moenyFomat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    statusFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 0:
          str = '未激活'
          break
        case 1:
          str = '正常'
          break
      }
      return str
    },
    idFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 1:
          str = '福利制表人/福利审核人'
          break
        case 2:
          str = '福利审核人'
          break
        case 3:
          str = '福利制表人'
          break
        case 4:
          str = '普通员工'
          break
      }
      return str
    },
    querySearch (queryString) {
      let that = this
      this.page = 1
      let data = {
        id: that.companyId,
        page: that.page,
        size: that.pageSize,
        keyword: queryString
      }
      serMatesByCompanyId(data).then(res => {
        console.log(res)
        that.mates = res.data.employeeList
        console.log(that.mates)
        this.total = res.data.count
      })
    },
    inputChange (val) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (val) {
        this.timer = setTimeout(() => {
          this.querySearch(val)
        }, 500)
      } else {
        this.querySearch(val)
      }
    },
    // 切换弹窗
    deductionBox () {
      this.delVisible = false
      setTimeout(() => {
        this.delVisibles = true
      }, 500)
    },
    // 点击赋值
    assignment () {
      this.deductionInput = this.account
    },
    // 关闭弹窗
    handleDialogClose () {
      this.delVisibles = false
      this.succ = false
      setTimeout(() => {
        this.deductionInput = ''
      }, 500)
    },
    // 判断设备
    device () {
      var u = navigator.userAgent
      var device = '' // 当前设备信息
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        // 安卓手机
        return device = 'Android'
      } else if (u.indexOf('iPhone') > -1) {
        // 苹果手机
        return device = 'iPhone'
      } else if (u.indexOf('Windows Phone') > -1) {
        // winphone手机
        return device = 'Windows Phone'
      } else {
        return device = 'web'
      }
    },
    // 元转分
    regYuanToFen (arg1, multiple) {
      var m = 0
      var s1 = arg1.toString()
      var s2 = multiple.toString()
      try { m += s1.split('.')[1].length } catch (e) {}
      try { m += s2.split('.')[1].length } catch (e) {}
      return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    },
    pageChange (page) {
      this.page = page
      if (this.searchStr) {
        let data = {
          id: this.companyId,
          page: this.page,
          size: this.pageSize,
          keyword: this.searchStr
        }
        serMatesByCompanyId(data).then(res => {
          this.mates = res.data.employeeList
          this.total = res.data.count
        })
      } else {
        if (this.deptId == '全部部门' || this.deptId == 0) {
          this.getMates(page)
        } else {
          let data = {
            id: this.companyId,
            page: this.page,
            size: this.pageSize,
            deptId: this.deptId
          }
          serMatesByDepartment(data).then(res => {
            // console.log(res);
            this.mates = res.data.employeeList
            this.total = res.data.count
          })
        }
      }
    },
    selectChange (value) {
      this.page = 1
      this.deptId = value
      // console.log(this.deptId)
    },
    searchList (event, item) {
      // console.log(event, item);
      this.page = 1
      this.deptId = event
      if (event === '全部部门') {
        let data = {
          id: this.companyId,
          page: this.page,
          size: this.pageSize
        }
        // console.log(data);
        getMatesByCompanyId(data).then(res => {
          // console.log(res);
          this.mates = res.data.employeeList
          this.total = res.data.count
        })
      } else {
        if (event == 0) {
          this.deptId = 0
        } else {
          this.deptId = event
        }
        this.pageChange(1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
%row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container{
  .top{
    @extend %row;
    justify-content: space-between;
    margin-bottom: 20px;
    p{
      flex-basis: 20%;
    }
    .search-warp{
      flex:1;
      display: flex;
      justify-content: flex-end;
      .search{
        width: 30%;
        margin:0 4%;
      }
    }
  }
}
.tip{
  color:#409EFF;
  cursor:pointer;
}
.error{
  color: lightcoral;
}
.box{
  display: flex;
  justify-content: space-between;
  .font{
    font-size: 14px;
    line-height: 20px;
  }
}
.dialog-footer{
  display: flex;
  justify-content: space-around;
  .el-button--primary{
    background:#2ecc74;
    border:1px solid #2ecc74;
  }
}
.confirm{
  text-align: center;
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .font{
      flex-basis:20%;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
    }
    .input{
      flex-basis:65%;
      flex: 1;
    }
    .unit{
      flex-basis:5%;
      text-align: right;
    }
  }
  .prompt{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:20px;
    .text{
      font-size: 14px;
      line-height: 20px;
    }
    .assignment{
      cursor:pointer;
    }
  }
  .tips{
    font-size: 12px;
    line-height: 18px;
    color:#FF5000;
    text-align: left;
    margin-top: 11px;
  }
  .remark{
    font-size: 12px;
    line-height: 18px;
    color:#999999;
    text-align: left;
    margin-top: 20px;
  }
  .hidden{
    display: none;
  }
}
.succ{
  .boxs{
    display: flex;
    justify-content: flex-start;
    .font{
      .color{
        color:#409EFF;
      }
    }
  }
}
.select{
  width:100%;
  ::v-deep  .el-input--small .el-input__inner{
    width:100%;
    height: 40px;
    line-height: 40px;
  }
}
.checkbox{
  margin-top:20px;
  align-items: center;
}
.positive{
  position: relative;
}
.icon{
  display:inline-block;
  width:15px;
  height:15px;
  position: absolute;
  top:1px;
  right:-20px;
}
.delIcon{
  width:20px;
  height:20px;
  position: absolute;
  top:30%;
  right:2%;
  z-index: 10;
  display: none;
}
::v-deep  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover .delIcon{
  display: block;
}
</style>
